class ReviewsSlider {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('[data-track]');
    this.slides = container.querySelectorAll('.reviews-slider__slide');
    this.prevButton = container.querySelector('[data-prev]');
    this.nextButton = container.querySelector('[data-next]');
    
    this.init();
  }

  init() {
    if (this.slides.length <= 1) return;

    // Bind event listeners
    this.prevButton?.addEventListener('click', () => this.prevSlide());
    this.nextButton?.addEventListener('click', () => this.nextSlide());

    // Update navigation on scroll
    this.track.addEventListener('scroll', () => this.updateNavigationButtons());

    // Keyboard navigation
    this.addKeyboardSupport();

    // Initial update
    this.updateNavigationButtons();
  }

  prevSlide() {
    const slideWidth = this.slides[0]?.offsetWidth + 20; // 20px = gap
    const currentScroll = this.track.scrollLeft;
    
    // If at the beginning, go to the end (infinite scroll)
    if (currentScroll <= 0) {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.track.scrollTo({
        left: maxScroll,
        behavior: 'smooth'
      });
    } else {
      this.track.scrollTo({
        left: currentScroll - slideWidth,
        behavior: 'smooth'
      });
    }
  }

  nextSlide() {
    const slideWidth = this.slides[0]?.offsetWidth + 20; // 20px = gap
    const currentScroll = this.track.scrollLeft;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    
    // If at the end, go to the beginning (infinite scroll)
    if (currentScroll >= maxScroll - 1) {
      this.track.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    } else {
      this.track.scrollTo({
        left: currentScroll + slideWidth,
        behavior: 'smooth'
      });
    }
  }

  updateNavigationButtons() {
    // Remove disabled state for infinite scroll
    if (this.prevButton) {
      this.prevButton.disabled = false;
    }
    
    if (this.nextButton) {
      this.nextButton.disabled = false;
    }
  }



  addKeyboardSupport() {
    this.container.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          this.prevSlide();
          break;
        case 'ArrowRight':
          e.preventDefault();
          this.nextSlide();
          break;
        case 'Home':
          e.preventDefault();
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
          break;
        case 'End':
          e.preventDefault();
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          this.track.scrollTo({ left: maxScroll, behavior: 'smooth' });
          break;
      }
    });

    // Make container focusable for keyboard navigation
    this.container.setAttribute('tabindex', '0');
  }
}

// Initialize all review sliders on the page
document.addEventListener('DOMContentLoaded', () => {
  const reviewSliders = document.querySelectorAll('.reviews-slider');
  
  reviewSliders.forEach(slider => {
    new ReviewsSlider(slider);
  });
});

// Handle dynamic content (for theme editor)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('reviews-section')) {
    const slider = event.target.querySelector('.reviews-slider');
    if (slider) {
      new ReviewsSlider(slider);
    }
  }
});

// Handle section reloads in theme editor
document.addEventListener('shopify:section:reorder', (event) => {
  const reviewSliders = document.querySelectorAll('.reviews-slider');
  
  reviewSliders.forEach(slider => {
    new ReviewsSlider(slider);
  });
});

// Export for potential external use
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ReviewsSlider;
} else if (typeof window !== 'undefined') {
  window.ReviewsSlider = ReviewsSlider;
} 